import type { User } from '@/common/user.common'
import { type SessionResponseDTO, type SignupDTO } from './dto/auth.dto'
import { API, API_PUBLIC } from '.'

// Login
export function loginApi(email: string, password: string) {
  return API_PUBLIC<User>(
    `/auth/signin`,
    {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    },
    'Invalid credentials.',
    'UNAUTHORIZED'
  )
}

//Signup
export function signupApi(payload: SignupDTO) {
  return API_PUBLIC(
    `/auth/signup`,
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
    'Fehler bei der Registrierung.',
    'SIGNUP_FAILED'
  )
}

export function confirmApi(token: string) {
  return API_PUBLIC(
    `/auth/confirm`,
    {
      method: 'POST',
      body: JSON.stringify({ token }),
    },
    'Bestätigung fehlgeschlagen.',
    'CONFIRMATION_FAILED'
  )
}
export function resendSignupEmailApi(email: string) {
  return API_PUBLIC(
    `/auth/resend-confirmation`,
    {
      method: 'POST',
      body: JSON.stringify({ email }),
    },
    'Fehler beim erneuten Senden der Bestätigungs-E-Mail.',
    'RESEND_CONFIRMATION_FAILED'
  )
}

// === Forgot Password: request email ===
export function requestPasswordReset(email: string) {
  return API_PUBLIC(
    `/auth/forgot-password`,
    {
      method: 'POST',
      body: JSON.stringify({ email }),
    },
    'Fehler beim Anfordern des Zurücksetzungslinks.',
    'FORGOT_PASSWORD_FAILED'
  )
}

// === Password Reset: submit new password ===
export function resetPassword(token: string, newPassword: string) {
  return API_PUBLIC(
    `/auth/reset-password`,
    {
      method: 'POST',
      body: JSON.stringify({ token, newPassword }),
    },
    'Fehler beim Zurücksetzen des Passworts.',
    'RESET_PASSWORD_FAILED'
  )
}

export function getSessionApi() {
  return API<SessionResponseDTO>(`/auth/session`, {}, 'Unauthorized', 'UNAUTHORIZED')
}

export function logoutApi() {
  return API_PUBLIC(`/auth/logout`, { method: 'POST' }, 'Logout failed', 'LOGOUT_FAILED')
}
